import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MainPage from './pages/MainPage';
import ChallengePage from './pages/ChallengePage';
import SongCreationPage from './pages/SongCreationPage';
import { MantineProvider } from '@mantine/core';

function App() {
  return (
    <MantineProvider defaultColorScheme="dark">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/create" element={<SongCreationPage />} />
          <Route path="/challenge/:id" element={<ChallengePage />} />
        </Routes>
      </BrowserRouter>
    </MantineProvider>
  );
}

export default App;
